// extracted by mini-css-extract-plugin
export default {"nav":"PageNav_nav__CkyEC","menuList":"PageNav_menuList__blF02","menuItems":"PageNav_menuItems__rkGIn"};